import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import store from '../../store'
import { qs, qsa } from '../../utils'
import DefaultRenderer from './Default'

Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

class ProductsRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    qs('.disclaimer')?.classList?.remove?.('hide')
    // store.resizeFn = this.onResize.bind(this);
    store.resizeFn = null
    store.section = 'home'
    this.setHeaderStyle('white')
    this.onPageChange()
    this.slideHome()
  }

  onEnter() {
    super.onEnter()
    qs('.disclaimer')?.classList?.remove?.('hide')
    qs('.disclaimer')?.classList?.add?.('products')
    qs('#header').classList.add('no-bg')
  }

  onLeave() {
    super.onLeave()
    qs('.disclaimer')?.classList?.add?.('hide')
    qs('.disclaimer')?.classList?.remove?.('products')
    qs('#header').classList.remove('no-bg')
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    // qs('.disclaimer') && qs('.disclaimer')?.classList?.add?.('hide');
    super.onLeaveCompleted()
  }

  slideHome() {
    // if (store.bounds.ww > 900)
    setTimeout(() => {
      const $slideHomeContent = qsa('.h-s-i-back')
      var maxHeight = 0
      $slideHomeContent.forEach(($elem) => {
        if ($elem.offsetHeight > maxHeight) maxHeight = $elem.offsetHeight
      })
      $slideHomeContent.forEach(($elem) => {
        $elem.style.height = maxHeight + 'px'
      })
    }, 1000)
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    let autoplayObj = {
      autoplay: {
        delay: 4000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    }
    if (!mediaQuery || mediaQuery.matches) {
      autoplayObj.autoplay = false
    }
    const homeSlide = new Swiper('.home-slide', {
      slidesPerView: 'auto',
      spaceBetween: 88,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      autoHeight: true,
      ...autoplayObj,
      loop: true,
      speed: 1000,
      pagination: {
        el: '.home-slide-dots',
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<button class="' +
            className +
            '" role="button">' +
            '<svg class="fp-arc-loader" width="16" height="16" viewBox="0 0 16 16">' +
            '<circle class="path" cx="8" cy="8" r="5.5" fill="none" transform="rotate(-90 8 8)" stroke="#FFF"' +
            'stroke-opacity="1" stroke-width="1.5px"></circle>' +
            '<circle cx="8" cy="8" r="3" fill="transparent"></circle>' +
            '</svg></button>'
          )
        },
      },
      breakpoints: {
        900: {
          autoHeight: false,
        },
      },
    })

    const homeSlideNumbers = new Swiper('#numbers-slide', {
      slidesPerView: 1,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: true,
      speed: 1000,
      ...autoplayObj,
      pagination: {
        el: '.home-slide-numbers-dots',
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<button class="' +
            className +
            '" role="button">' +
            '<svg class="fp-arc-loader" width="16" height="16" viewBox="0 0 16 16">' +
            '<circle class="path" cx="8" cy="8" r="5.5" fill="none" transform="rotate(-90 8 8)" stroke="#FFF"' +
            'stroke-opacity="1" stroke-width="1.5px"></circle>' +
            '<circle cx="8" cy="8" r="3" fill="transparent"></circle>' +
            '</svg></button>'
          )
        },
      },
    })

    const homeSlideLinks = new Swiper('#hero-links-slide', {
      slidesPerView: 2,
      // spaceBetween: 100,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: true,
      speed: 1000,
      ...autoplayObj,
    })

    const heroSlide = new Swiper('.hero-slide-text', {
      slidesPerView: 'auto',
      spaceBetween: 50,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      autoHeight: true,
      loop: true,
      speed: 1000,
      navigation: {
        nextEl: '.h-s-next',
        prevEl: '.h-s-prev',
      },
      breakpoints: {
        900: {
          autoplay: {
            delay: 5000,
            waitForTransition: true,
            disableOnInteraction: false,
          },
        },
      },
    })
  }
}

export default ProductsRenderer
